
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let modifiedReq = req;

    if (req.url.includes(environment.backEndUriBase)) {
      modifiedReq = req.clone({
        headers: req.headers.set('Ocp-Apim-Subscription-Key', environment.ocpApimSubscriptionKey),
      });
    }

    return next.handle(modifiedReq);
  }
}